import { render, staticRenderFns } from "./MailboxInfoPicker.vue?vue&type=template&id=be8e7b34&"
import script from "./MailboxInfoPicker.vue?vue&type=script&lang=js&"
export * from "./MailboxInfoPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports